'use client';
import Image from 'next/image';
import Link from 'next/link';
import Four from '../../public/updated-home/four-of-four/four-of.png';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function NOtfound() {
  return (
    <main className="relative isolate min-h-full">
      <Navbar />
      <div className="mx-auto max-w-7xl px-6 py-6 text-center sm:py-4 lg:px-8">
        <div className="flex justify-center  px-10 pt-5 mx-auto max-w-3xl">
          <Image src={Four} />
        </div>
        <h1 className="mt-4 text-3xl font-bold tracking-tight secondary sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-4 updatedpara secondary sm:mt-6">
          We're sorry, the page you requested could not be found please go back
          to the homepage
        </p>
        <div className=" flex justify-center">
          <Link href="/" className="text-sm font-semibold leading-7 text-white">
            <button className="bgseconday pr-4 pl-4 mb-7 pt-2 pb-2 rounded-xl mt-3">
              Back to home
            </button>
          </Link>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default NOtfound;
